import React from 'react';
import '../styles/bugWindow.css';
import { sendFeedback } from '../utility/api';

function BugWindow({ setIsBugWindowOpen }) {

    const [bugTitle, setBugTitle] = React.useState('');
    const [bugType, setBugType] = React.useState('bug');
    const [bugDescription, setBugDescription] = React.useState('');

    function onSubmit() {
        var bug = {
            title: bugTitle,
            type: bugType,
            description: bugDescription
        }

        if (bugTitle === '') {
            alert('Please add a title');
            return;
        }


        sendFeedback(bug).then(() => {
            setIsBugWindowOpen(false);
        });
    }


    return (
        <div className="bug-window-overlay">
            <div className="overlay" onClick={() => setIsBugWindowOpen(false)}></div>
            <div className="bug-window">
                <div className="close-btn" onClick={() => setIsBugWindowOpen(false)}>X</div>
                <div className="form-title">Give feedback or report a bug</div>
                <label className="form-label" htmlFor="bugTitle">Add a short title. *</label>
                <input type="text" id="bugTitle" className="form-input" onChange={(e) => setBugTitle(e.target.value)} autocomplete="off" />

                <label className="form-label" htmlFor="bugType">What kind of thing are you reporting?</label>
                <select id="bugType" className="form-select" onChange={(e) => setBugType(e.target.value)}>
                    <option value="bug">Bug</option>
                    <option value="feature">Feature Request</option>
                    <option value="feedback">Feedback</option>
                    <option value="other">Other</option>
                </select>

                <label className="form-label" htmlFor="bugDescription">Please describe your issue/feedback.</label>
                <textarea id="bugDescription" className="form-textarea" onChange={(e) => setBugDescription(e.target.value)} />

                <button className="form-button" type="submit" onClick={() => onSubmit()}>Submit</button>
            </div>
        </div>
    );
}

export default BugWindow;
